import mushroom from 'mushroomjs';

"use strict";

function generateSendMailUrl() {
    return mushroom._fnGetRootApiUrl() + "mailing/send";
}

function generateGetMailUrl(settings, token) {
    return mushroom._fnGetRootApiUrl() + "mailing/get?token=" + encodeURIComponent(token);
}

function generateDiscardMailUrl(settings, token) {
    return mushroom._fnGetRootApiUrl() + "mailing/discard?token=" + encodeURIComponent(token);
}

mushroom.$mail = mushroom.$mail || {};

mushroom.$mail.sendAsync = mushroom.__createAsyncRestFunction({
    name: "$mail.sendAsync",
    method: "POST",
    blankBody: false,
    url: generateSendMailUrl
});

mushroom.$mail.getAsync = mushroom.__createAsyncRestFunction({
    name: "$mail.getAsync",
    method: "GET",
    blankBody: true,
    url: generateGetMailUrl
});

mushroom.$mail.discardAsync = mushroom.__createAsyncRestFunction({
    name: "$mail.discardAsync",
    method: "DELETE",
    blankBody: true,
    url: generateDiscardMailUrl
});

export default mushroom;